import React, { useState, useEffect } from "react";
import { Table, Container } from "react-bootstrap";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { Link } from "react-router-dom";

const RecentOrders = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "Orders"));
        const fetchedOrders = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Sort orders by createdAt in descending order (most recent first)
        fetchedOrders.sort((a, b) => {
          const dateA = a.createdAt ? new Date(a.createdAt.seconds * 1000) : new Date(0);
          const dateB = b.createdAt ? new Date(b.createdAt.seconds * 1000) : new Date(0);
          return dateB - dateA;
        });

        // Get only the 5 most recent orders
        setOrders(fetchedOrders.slice(0, 5));
      } catch (error) {
        console.error("Error fetching orders: ", error);
      }
    };

    fetchOrders();
  }, []);

  // Helper to get status badge class (unchanged)
  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "Delivered":
        return "bg-success";
      case "Pending":
        return "bg-warning";
      case "Cancelled":
        return "bg-danger";
      default:
        return "bg-warning";
    }
  };

  return (
    <Container>
      <h4 className="mb-3">Recent Orders</h4>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Date</th>
            <th>Name</th>
            <th>Ship To</th>
            <th>Car Number</th>
            <th>Model</th>
            <th>Sale Amount</th>
            <th>Discount</th>
            <th>Pending Amount</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {orders.length > 0 ? (
            orders.map((order, index) => (
              <tr key={order.id}>
                {/* Display createdAt converted to a locale date string */}
                <td>
                  {order.createdAt
                    ? new Date(order.createdAt.seconds * 1000).toLocaleDateString()
                    : "N/A"}
                </td>
                <td>{order.details?.name || "N/A"}</td>
                <td>{order.details?.address || "N/A"}</td>
                <td>{order.details?.carNumber || "N/A"}</td>
                <td>{order.details?.model || "N/A"}</td>
                {/* If order.price exists and is an array, use its elements:
                    [0] = Sale Amount, [1] = Pending Amount, [2] = Discount */}
                <td>
                  ${order.price && Array.isArray(order.price)
                    ? order.price[0]
                    : order.total || "N/A"}
                </td>
                <td>
                  ${order.price && Array.isArray(order.price)
                    ? order.price[2]
                    : order.discount || "N/A"}
                </td>
                <td>
                  ${order.price && Array.isArray(order.price)
                    ? order.price[1]
                    : order.totalPrice || "N/A"}
                </td>
                <td>
                  <span className={`badge ${getStatusBadgeClass(order.status)}`}>
                    {order.status || "pending"}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9">No orders found.</td>
            </tr>
          )}
        </tbody>
      </Table>
      <Link to="/admin/displayorder">See more orders</Link>
    </Container>
  );
};

export default RecentOrders;
